import { Routes } from "@angular/router";
import { AuthGuard } from "../../core/guards/auth-guard.service";
import { PermissionGuard } from "@core/guards/permission.guard";

export const centralRoutes: Routes = [
  {
    path: "config_inicio",
    loadComponent: () =>
      import("./components/inicio-central/inicio-central.component").then(
        (m) => m.InicioCentralComponent
      ),
    data: {
      label: "Inicio",
      icon: "home",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_empresas",
    loadChildren: () =>
      import("./components/empresas/empresas.routes").then(
        (m) => m.empresasRoutes
      ),
    data: {
      label: "Empresas",
      icon: "work",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_niveles-aprobacion",
    loadComponent: () =>
      import("./components/niveles/niveles.component").then(
        (m) => m.NivelesComponent
      ),
    data: {
      label: "Niveles",
      icon: "fact_check",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_feriados",
    loadComponent: () =>
      import("./components/feriados/feriados.component").then(
        (m) => m.FeriadosComponent
      ),
    data: {
      label: "Feriados",
      icon: "event",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
   {
    path: "config_cres-niveles",
    loadComponent: () =>
      import("./components/niveles-organizacion/niveles-organizacion.component").then(
        (m) => m.NivelesOrganizacionComponent
      ),
    data: {
      label: "Niveles de Organización",
      icon: "fact_check",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_cres-empresas",
    loadComponent: () =>
      import("./components/centros-empresa/centros-empresa.component").then(
        (m) => m.CentrosEmpresaComponent,
      ),
    data: {
      label: "Centros por Empresa",
      icon: "fact_check",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_cres-usuarios",
    loadComponent: () =>
      import("./components/cres-usuarios/cres-usuarios.component").then(
        (m) => m.CresUsuariosComponent,
      ),
    data: {
      label: "Usuarios",
      icon: "people",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_usuarios-division",
    loadComponent: () =>
      import("./components/usuarios-obra/usuarios-obra.component").then(
        (m) => m.UsuariosObraComponent
      ),
    data: {
      label: "Usuarios División",
      icon: "group",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_usuarios-empresa",
    loadComponent: () =>
      import("./components/usuarios-empresa/usuarios-empresa.component").then(
        (m) => m.UsuariosEmpresaComponent
      ),
    data: {
      label: "Usuarios Empresa",
      icon: "business",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_restriccion-legajos",
    loadComponent: () =>
      import("./components/restriccion-legajos/restriccion-legajos.component").then(
        (m) => m.RestriccionLegajosComponent
      ),
    data: {
      label: "Restricción de Acceso a Legajos",
      icon: "account_tree",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_provincias",
    loadComponent: () =>
      import("./components/provincias/provincias.component").then(
        (m) => m.ProvinciasComponent
      ),
    data: {
      label: "Provincias",
      icon: "map",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
    {
    path: "config_usuarios-pais",
    loadComponent: () =>
      import("./components/usuarios-pais/usuarios-pais.component").then(
        (m) => m.UsuariosPaisComponent
      ),
    data: {
      label: "Usuarios Pais",
      icon: "business",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_paises",
    loadComponent: () =>
      import("./components/paises/paises.component").then(
        (m) => m.PaisesComponent
      ),
    data: {
      label: "Países",
      icon: "public",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_codigos-atributo",
    loadChildren: () =>
      import("./components/codigos-atributo/atributos-empresa.routes").then(
        (m) => m.atributosEmpresaRoutes
      ),
    data: {
      label: "Atributos de Empresa",
      icon: "settings",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_atributo-empresa",
    loadComponent: () =>
      import("./components/atributos-por-empresa/atributos-por-empresa.component").then(
        (m) => m.AtributosPorEmpresaComponent
      ),
    data: {
      label: "Atributos por Empresa",
      icon: "settings",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_localidades",
    loadComponent: () =>
      import("./components/localidades/localidades.component").then(
        (m) => m.LocalidadesComponent
      ),
    data: {
      label: "Localidades",
      icon: "location_city",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_nacionalidades",
    loadComponent: () =>
      import("./components/nacionalidades/nacionalidades.component").then(
        (m) => m.NacionalidadesComponent
      ),
    data: {
      label: "Nacionalidades",
      icon: "flag",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_documentos",
    loadComponent: () =>
      import("./components/documento-pais/documento-pais.component").then(
        (m) => m.DocumentosComponent
      ),
    data: {
      label: "Documentos",
      icon: "badge",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_unidades-monetarias",
    loadComponent: () =>
      import("./components/unidades-monetarias/unidades-monetarias.component").then(
        (m) => m.UnidadesMonetariasComponent
      ),
    data: {
      label: "Unidades Monetarias",
      icon: "attach_money",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_valuacion-unidades-monetarias",
    loadComponent: () =>
      import(
        "./components/valuacion-unidades-monetarias/valuacion-unidades-monetarias.component"
      ).then((m) => m.ValuacionUnidadesMonetariasComponent),
    data: {
      label: "Valuación de Unidades Monetarias",
      icon: "currency_exchange",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_divisiones",
    loadComponent: () =>
      import("./components/divisiones/divisiones.component").then(
        (m) => m.DivisionesComponent
      ),
    data: {
      label: "Divisiones",
      icon: "account_tree",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_combinacion-divisiones",
    loadComponent: () =>
      import("./components/combinacion-divisiones/combinacion-divisiones.component").then(
        (m) => m.CombinacionDivisionesComponent
      ),
    data: {
      label: "Combinación de Divisiones",
      icon: "merge_type",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_obj-imputacion",
    loadComponent: () =>
      import("./components/obj-imputacion/obj-imputacion.component").then(
        (m) => m.ObjImputacionComponent
      ),
    data: {
      label: "Objetos de Imputación",
      icon: "category",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_cuentas-empresa",
    loadComponent: () =>
      import("./components/cuentas-empresa/cuentas-empresa.component").then(
        (m) => m.CuentasEmpresaComponent
      ),
    data: {
      label: "Ctas. Bancarias de Débito por Empresa",
      icon: "account_balance",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "config_parametrico-auditorias",
    loadComponent: () =>
      import("./components/parametrico-auditorias/parametrico-auditorias.component").then(
        (m) => m.ParametricoAuditoriasComponent
      ),
    data: {
      label: "Parametrización de Auditoría",
      icon: "policy",
      urlexterna: "CEN",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
];
